<template>
    <div class="input-group ">
        <div class="input-group-prepend w-35 mw-auto">
        <span class="input-group-text w-100">
                {{label}}
                <small class="red--text" v-if="this.require">【必須】</small>
        </span>
        </div>
        <select @change="selectQualification(input)" class="custom-select" v-bind:id="id" v-bind:name="name"
                v-model="input">
            <option v-if="this.nullable" value=""/>
            <option v-if="this.allable" value="">全て</option>
            <option v-bind:value="qualification.id" v-for="qualification in filteredQualifications">
                {{ qualification.name }}
            </option>
        </select>
        <div class="invalid-feedback d-block">{{ error }}</div>
    </div>
</template>

<script>
    export default {
        name: "selectQualificationComponent",
        props: {
            label: String,
            name: String,
            id: String,
            require: {
                type: Boolean,
                default: false
            },
            nullable: {
                type: Boolean,
                default: false
            },
            allable: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isInit: true,
                input: "",
                description: "",
                description_category: "",
                qualifications: {},
                error: null,
            }
        },
        mounted() {
            appUtil.getAction('/admin/api/staff/qualification/search')
                .then(response => {
                    this.qualifications = response.data.qualifications;
                });
        },
        methods: {
            selectQualification(id) {
                let qualification = this.qualifications.filter(el => {
                    return el.id === id;
                });
                this.description = qualification[0].name;
                this.description_category = qualification[0].qualification_category.name;
            }
        },
        computed: {
            filteredQualifications() {
                if (!this.qualifications.length) {
                    return null;
                }
                if (this.isInit) {
                    this.isInit = false;
                } else {
                    this.input = "";
                }

                return this.qualifications.filter(el => {
                    if (!this.$store.state.qualification_category.id) {
                        return true;
                    }
                    return el.qualification_category_id === this.$store.state.qualification_category.id;
                });
            }
        }
    }
</script>

<style scoped>

</style>